$(document).ready(function () {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('tx_solr[filter]') || urlParams.has('tx_solr[sort]')) {
        let a = document.getElementsByClassName("results-topic")[0];
        $(a).find('a')[0].focus();
    }
});